module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedUltraBoldItalic.10e5451.woff2";